"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es7.string.pad-start");
var _gray_route_log = require("@/api/cfg/gray_route_log");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'GrayRouteLog',
  data: function data() {
    return {
      loading: false,
      list: [],
      total: 0,
      timeRange: [],
      queryParams: {
        page: 1,
        limit: 20,
        openId: null,
        userId: null,
        pagePath: null,
        source: null,
        mobilePhone: null,
        cardNo: null,
        startTime: null,
        endTime: null
      }
    };
  },
  created: function created() {
    this.getList();
  },
  methods: {
    getList: function getList() {
      var _this = this;
      this.loading = true;
      if (this.timeRange && this.timeRange.length === 2) {
        this.queryParams.startTime = this.timeRange[0];
        this.queryParams.endTime = this.timeRange[1];
      } else {
        this.queryParams.startTime = null;
        this.queryParams.endTime = null;
      }
      (0, _gray_route_log.getGrayRouteLogPage)(this.queryParams).then(function (response) {
        _this.list = response.data.list || [];
        _this.total = response.data.total || 0;
        _this.loading = false;
      }).catch(function () {
        _this.loading = false;
      });
    },
    handleQuery: function handleQuery() {
      this.queryParams.page = 1;
      this.getList();
    },
    handleReset: function handleReset() {
      this.queryParams = {
        page: 1,
        limit: 20,
        openId: null,
        userId: null,
        pagePath: null,
        source: null,
        mobilePhone: null,
        cardNo: null,
        startTime: null,
        endTime: null
      };
      this.timeRange = [];
      this.getList();
    },
    handleSizeChange: function handleSizeChange(size) {
      this.queryParams.limit = size;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(current) {
      this.queryParams.page = current;
      this.getList();
    },
    sourceLabel: function sourceLabel(source) {
      var map = {
        CITY: '城市',
        STORE_ID: '门店',
        IP_GEO: 'IP'
      };
      return map[source] || source;
    },
    sourceTagType: function sourceTagType(source) {
      var map = {
        CITY: 'success',
        STORE_ID: 'warning',
        IP_GEO: 'info'
      };
      return map[source] || '';
    },
    formatDateTime: function formatDateTime(cellValue) {
      if (!cellValue) return '';
      var d = new Date(cellValue);
      var y = d.getFullYear();
      var m = String(d.getMonth() + 1).padStart(2, '0');
      var day = String(d.getDate()).padStart(2, '0');
      var h = String(d.getHours()).padStart(2, '0');
      var min = String(d.getMinutes()).padStart(2, '0');
      var s = String(d.getSeconds()).padStart(2, '0');
      return y + '-' + m + '-' + day + ' ' + h + ':' + min + ':' + s;
    }
  }
};